import {
  NOTIFY_TYPE_SUBSCRIBE,
  NOTIFY_CONTENT_TYPE_IMG,
  // NOTIFY_CONTENT_TYPE_TXT,
  NOTIFY_CONTENT_TYPE_WIDGET,
  NOTIFY_BASE_WIDGET_DATA,
  NOTIFY_BASE_IMG_URL,
} from './constants';

/**
 * initial hardcoded data for the first known notifier mechs example,
 * although, it would be overwritten by incoming data from model
 * TODO: Refactor initState when second notifier example must be done
 */
const initialState = {
  useNotification: true,
  isOpen: false,
  notificationType: NOTIFY_TYPE_SUBSCRIBE,
  notificationContent: [
    {
      type: NOTIFY_CONTENT_TYPE_IMG,
      content: {
        src: NOTIFY_BASE_IMG_URL,
      },
    },
    {
      type: NOTIFY_CONTENT_TYPE_WIDGET,
      content: {
        ...NOTIFY_BASE_WIDGET_DATA,
      },
    },
  ],
};

export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
